import React from 'react';
import ReactHtmlParser from "react-html-parser";
function QuickNotes(props) {
    const { notes, isHtmlStr } = props;
    return (
        <div>{isHtmlStr ? ReactHtmlParser(notes) : notes}</div>
    )
}

export default QuickNotes